export default __webpack_public_path__ + "static/media/service_item_03.aba901a8.png";